<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form action="">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field
                          v-model="filters.accmType"
                          :label="labels.accmType"
                          :error-messages="errors.collect('accmType')"
                          data-vv-name="accmType"
                          :data-vv-as="labels.accmType"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field
                          v-model="filters.blkGrp"
                          :label="labels.blkGrp"
                          :error-messages="errors.collect('blkGrp')"
                          data-vv-name="blkGrp"
                          :data-vv-as="labels.blkGrp"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="filters.blkGrpDescS"
                          :label="labels.blkGrpDescS"
                          :error-messages="errors.collect('blkGrpDescS')"
                          data-vv-name="blkGrpDescS"
                          :data-vv-as="labels.blkGrpDescS"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-1"></v-spacer>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Block Group
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        v-bind:options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        :no-data-text="noDataText"
      >
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.accmType }}</td>
            <td class="text-xs-left">{{ row.item.blkGrp }}</td>
            <td class="text-xs-left">{{ row.item.blkGrpDescS }}</td>
            <td class="table-action-header">
              <table-action
                :rowData="row"
                review
                @review="doAction('edit', row.item)"
                query
                @query="doAction('query', row.item)"
                remove
                @remove="doPromptRemove"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove">
      Please confirm deletion of this records. ( {{ selectedBlkGrp.accmType + ' ' + selectedBlkGrp.blkGrp }} )
    </confirm>
    <div v-if="blkGrpReview">
      <v-dialog v-model="blkGrpReview" width="800px" persistent>
        <blk-grp-review :blkGrpForm="blkGrpForm" :mode="mode" @close="doClose"></blk-grp-review>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import BlkGrpReview from './BlockGroupReview'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Accumulation Type', align: 'left', value: 'accmType' },
        { text: 'Block Group', align: 'left', value: 'blkGrp' },
        { text: 'Short Description', align: 'left', value: 'blkGrpDescS' },
        TableConst.tableActionHeader
      ],
      labels: {
        accmType: 'Accumulation Type',
        blkGrp: 'Block Group',
        blkGrpDescS: 'Short Description'
      },
      blkGrpForm: {
        accmType: null,
        blkGrp: null,
        blkGrpDescS: null,
        blkGrpDescL: null,
        blkGrpAe: false,
        remark: null,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      sideFunction: [
        {
          text: 'Block Sub Group 1',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'blkSubGrp1' }
        },
        {
          text: 'Block Sub Group 2',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'blkSubGrp2' }
        },
        {
          text: 'Block',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'blk' }
        },
        {
          text: 'Block Treaty Limit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'blkTtyLim' }
        }
      ],
      totalItems: 0,
      promptRemove: false,
      mode: '',
      blkGrpReview: false,
      selectedBlkGrp: {},
      loading: false,
      accmTypeList: [],
      filters: {
        accmType: undefined,
        blkGrp: undefined,
        blkGrpDescS: undefined
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getBlkGrpList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((blkGrp) => {
                const convertList = {
                  accmType: blkGrp.accmType,
                  blkGrp: blkGrp.blkGrp,
                  blkGrpDescS: blkGrp.blkGrpDescS
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.accmType = undefined
      this.filters.blkGrp = undefined
      this.filters.blkGrpDescS = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    async doAction(mode, listData) {
      const apiURI = this.menu.getBlkGrp
      if (apiURI) {
        try {
          const expand = {
            accmType: listData.accmType,
            blkGrp: listData.blkGrp
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.blkGrpForm.accmType = data.blkGrp.accmType
            this.blkGrpForm.blkGrp = data.blkGrp.blkGrp
            this.blkGrpForm.blkGrpDescS = data.blkGrp.blkGrpDescS
            this.blkGrpForm.blkGrpDescL = data.blkGrp.blkGrpDescL
            this.blkGrpForm.blkGrpAe = data.blkGrp.blkGrpAe
            this.blkGrpForm.remark = data.blkGrp.remark
            this.blkGrpForm.createdName = data.blkGrp.createdName
            this.blkGrpForm.createdDate = data.blkGrp.createdDate
            this.blkGrpForm.modifiedName = data.blkGrp.modifiedName
            this.blkGrpForm.modifiedDate = data.blkGrp.modifiedDate

            this.mode = mode
            this.blkGrpReview = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.mode = 'new'
      this.blkGrpReview = true
    },
    doClose() {
      this.blkGrpReview = false
      this.doInit()
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedBlkGrp = data.item
      this.promptRemove = true
    },
    async doRemove(data) {
      const apiURI = this.menu.deleteBlkGrp
      if (apiURI) {
        const expand = this.selectedBlkGrp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    }
  },
  mounted() {
    this.doInit()
    this.getAccmTypeList()
  },
  components: {
    BlkGrpReview,
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
